export default {
  id: 17, type: '+', iconName: 'hongbao', text: '红包'
};